import "src/styles/f.css.ts.vanilla.css!=!../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/styles/f.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA5WTy27bMBBF9/4KbgI4QGhITZ3WyscEI3EkjU2RAknZMYL+e4ekH2GaTQFpId0zD17ObN7ql/q4wK4SHyshFPlZw7kRgyP1uvqz2lz1utR7je+F/iPpoGkwkgJOvhEdmoCuoJ4TtV98oP4sO8uACd+SPxMZy0hFDrtA1jBo9TKZAtzewEbUhfKSlNl6ysHQeg4PWEC/vkAONQQ6ltDvBAU7N6IqhF0SNPbhqwJJOZEKI/dVVQ+F2iZ1RBrG8I2scvDIRko/Q4eNMPbkYC4ozJbPM4IDkyHDjQvRWqfQpZb4bKAUmeHy1UJ3GJxdjLrj7Kpl+ghuLaVHVNJ3oFGm/3JwcJa7qnqMaMD3INMtN+nYRUN9auh/synsrIPsfu7oU8ohp1ycjzlnS3lQhJAnbA8UZIBZjmyjjlbKS+3AfrBvjseqyDambPaIrtf21IiRlEKTOokRvXXTJZiHAJ/VunoS8UnNTuAPkiYY2OhrdQeKQMdDKeJi63RlT6LV7PJjUZqK0pJXyHfOav35LDc1S+nSgl26sczUNNeAzLXgyuX8x8V9HlMyKG8zt6m3BXPIDbZ73jXZU9zK2M/r/ed9SbbVQ3w5/i/MJ4ZLQAQAAA==\"}!../../node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js"
export var cursorPointer = '_161vua9g';
export var flex = '_161vua91';
export var flex1 = '_161vua95';
export var flexAlignCenter = '_161vua92 _161vua91';
export var flexColumn = '_161vua94 _161vua91';
export var flexJustifyCenter = '_161vua93 _161vua91';
export var fullHeight = '_161vua9b';
export var fullWidth = '_161vua9a';
export var grid = '_161vua90';
export var imgObjectFitCover = '_161vua9k';
export var left0 = '_161vua99';
export var nowrap = '_161vua9d';
export var overflowHidden = '_161vua9h';
export var overflowScroll = '_161vua9i';
export var posAbs = '_161vua96';
export var posAbsFull = '_161vua96 _161vua98 _161vua99 _161vua9a _161vua9b';
export var posRel = '_161vua97';
export var resetAnchor = '_161vua9f';
export var resetButton = '_161vua9e';
export var rootLineHeight = '_161vua9j';
export var top0 = '_161vua98';